export enum ReturnStatus {
  Offen = 'OFFEN',
  InBearbeitung = 'IN_BEARBEITUNG',
  Erfasst = 'ERFASST',
  // V2: Genehmigt = 'GENEHMIGT',
  // V2: Abgelehnt = 'ABGELEHNT',
}
